export default __webpack_public_path__ + "static/media/Yi Liu_resume.42cb64d8.pdf";